import { pauseToastLife, resumeToastLife } from './hoverPause';

export const toast = {
  root: ({ props }: Record<string, any>) => ({
    class: [
      // Size and Shape
      'w-96 rounded-md',
      // Positioning
      {
        '-translate-x-2/4': props.position === 'top-center' || props.position === 'bottom-center',
      },
    ],
  }),
  message: ({ props, instance }: Record<string, any>) => ({
    // zolang de muis op de melding staat blijft hij staan, daarna loopt de resttijd door
    onMouseenter: () => pauseToastLife(instance),
    onMouseleave: () => resumeToastLife(instance),
    class: [
      'mb-4 rounded-md w-full',
      'border border-transparent',
      'backdrop-blur-[10px] shadow-md',
      // Colors
      {
        'bg-blue-50/90': props.message.severity === 'info',
        'bg-green-50/90': props.message.severity === 'success',
        'bg-orange-200/90': props.message.severity === 'warn',
        'bg-red-50/90': props.message.severity === 'error',
      },
      {
        'border-info-200': props.message.severity === 'info',
        'border-green-200': props.message.severity === 'success',
        'border-orange-200': props.message.severity === 'warn',
        'border-red-200': props.message.severity === 'error',
      },
      {
        'text-blue-700': props.message.severity === 'info',
        'text-green-700': props.message.severity === 'success',
        'text-orange-700': props.message.severity === 'warn',
        'text-red-700': props.message.severity === 'error',
      },
    ],
  }),
  messageContent: ({ props }: Record<string, any>) => ({
    class: [
      'flex p-3 justify-between overflow-wrap-anywhere',
      {
        'items-start': props.message.summary,
        'items-center': !props.message.summary,
      },
    ],
  }),
  messageIcon: {
    class: [
      // Sizing and Spacing
      'w-[1.125rem] h-[1.125rem] mr-2',
      'text-lg leading-[normal]',
    ],
  },
  messageText: {
    class: ['text-base leading-[normal]', 'ml-2', 'flex-1'],
  },
  summary: {
    class: 'font-medium block',
  },
  detail: ({ props }: Record<string, any>) => ({
    class: ['block', 'text-sm', 'text-black', { 'mt-2': props.message.summary }],
  }),
  closeButton: ({ props }: Record<string, any>) => ({
    class: [
      // Flexbox
      'flex items-center justify-center',
      // Size
      'w-7 h-7',
      // Spacing and Misc
      'ml-auto  relative',
      // Shape
      'rounded-full',
      // Colors
      'bg-transparent',
      // Transitions
      'transition duration-200 ease-in-out',
      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-1',
      {
        'focus:ring-blue-500': props.message.severity === 'info',
        'focus:ring-green-500': props.message.severity === 'success',
        'focus:ring-orange-500': props.message.severity === 'warn',
        'focus:ring-red-500': props.message.severity === 'error',
      },
      // Misc
      'overflow-hidden',
    ],
  }),
  transition: {
    enterFromClass: 'opacity-0 translate-y-2/4',
    enterActiveClass: 'transition-[transform,opacity] duration-300',
    leaveFromClass: 'max-h-[1000px]',
    leaveActiveClass:
      '!transition-[max-height_.45s_cubic-bezier(0,1,0,1),opacity_.3s,margin-bottom_.3s] overflow-hidden',
    leaveToClass: 'max-h-0 opacity-0 mb-0',
  },
};
